/* Chiave condivisa del popup Squiddi AI: sta qui da sola così il redirect /ai
   in App.js può usarla senza tirare dentro tutto il widget della chat. */
export const AUTO_OPEN_KEY = "squiddi_chat_autoopen";
